/**
 * PATH: apps/quote/src/components/builder/scope-ag-grid/mapPickedItemToPriceBookItem.ts
 * FILE_ID: QB-AGGRID-PICK-MAP-002
 * PURPOSE: Pure I→O adapter from a @quotech/pricelist PickedItem (emitted by
 *          PricelistWorkbook.onPickItem in the split-screen drawer, with the
 *          section's quote_field mappings already resolved) to the PriceBookItem
 *          shape the existing pricelist-prefill builders read.
 * WHY: The drawer reuses the SAME prefill path as the old modal picker
 *      (usePricelistPicker.handleSelect → buildPricelistCreate/UpdatePayload).
 *      PickedItem already carries the resolved cost/sell/productivity/unit, so
 *      this is a thin field rename.
 * RELATED: pricelist-prefill.ts (consumer), @quotech/pricelist (PickedItem)
 */
import type { PickedItem } from '@quotech/pricelist'
import type { PriceBookItem } from '@/lib/api/pricing-api/types'

/** Map a resolved PickedItem → PriceBookItem for the prefill builders. */
export function mapPickedItemToPriceBookItem(picked: PickedItem): PriceBookItem {
  return {
    id: '',
    item_code: picked.item_code,
    item_name: picked.item_name,
    description: picked.description,
    item_type: 'material',
    unit: picked.unit || 'm2',
    base_cost: picked.cost ?? 0,
    markup_percent: 0,
    fixed_sell_price: picked.sell,
    pricing_method: 'fixed',
    computed_sell_price: picked.sell ?? undefined,
    productivity_pmpd: picked.productivity,
  }
}
